// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cuMY","content":"styles_content__2vJzO","row":"styles_row__1UL59","footer":"styles_footer__3mbFm","phraseLength":"styles_phraseLength__fyr8t"};